// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__dOZqP","header":"ClearentDisclaimer_header__Dte1U","inner":"ClearentDisclaimer_inner__8Q64e"};